// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 28 20", width: "28", height: "20" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("path", { fillRule: "nonzero", d: "M14,0 C6.2685,0 0,8.33333077 0,10 C0,11.6666692 6.2685,20 14,20 C21.7315,20 28,11.6666692 28,10 C28,8.33333077 21.7315,0 14,0 Z M14,14.6153846 C11.4228333,14.6153846 9.33333333,12.5488462 9.33333333,10 C9.33333333,7.45115385 11.4228333,5.38461538 14,5.38461538 C16.5771667,5.38461538 18.6666667,7.45115385 18.6666667,10 C18.6666667,12.5488462 16.5771667,14.6153846 14,14.6153846 Z" }))));
};
Icon.displayName = 'Eye28x20';
export default Icon;
//# sourceMappingURL=Eye28x20.js.map